export default __webpack_public_path__ + "media/images/content-dog-hands-18de1719fa6fc552fe3d5cb915a4cf36.png";